import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { HashLocationStrategy, LocationStrategy } from '@angular/common';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { LocalStorageService } from 'ngx-webstorage';
import { SlickCarouselModule } from 'ngx-slick-carousel';
import { NgSelectModule } from '@ng-select/ng-select';
import { DragScrollModule } from 'ngx-drag-scroll';
import { NgxMaskModule } from 'ngx-mask';
import { NotyfModule } from 'ng-notyf';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { InterceptorClass } from './interceptor/httpInterceptor';

import { HomeComponent } from './modules/home/home.component';
import { headerComponent } from './template/header/header.component';
import { subHeaderComponent } from './template/subheader/subheader.component';
import { footerComponent } from './template/footer/footer.component';

import { noInternetComponent } from './template/noInternet/noInternet.component';
import { SearchComponent } from './modules/shared/search/search.component';
import { CalendarComponent } from './modules/shared/calendar/calendar.component';
import { LoaderComponent } from './modules/shared/loader/loadar.component';
import { MyCartComponent } from './modules/shared/my-cart/my-cart.component';
import { RemovePastOrderComponent } from './modules/shared/remove-cart-past-order/remove-past-order.component';
import { RemoveCartItemComponent } from './modules/shared/remove-cart-item/remove.component';
import { ZipCodeComponent } from './modules/shared/zip-code/zip-code.component';
import { CartDatesPromptComponent } from './modules/shared/cart-dates-prompt/cart-dates-prompt.component';
import { SharedLibrariesModule } from './modules/shared/shared-libraries.module';
import { EditOrderSaveChangesComponent } from './modules/orders/edit/save-changes/save-changes.component';

import { AuthService } from './services/auth.service';
import { HomeService } from './services/home.service';
import { CommonService } from './services/common.service';
import { CategoryService } from './services/category.service';
import { DateTimeService } from './services/date-time.service';
import { AddressBookService } from './services/address.service';
import { AddressValidationService } from './services/address-validation.service';
import { ConfigurationService } from './services/config.service';
import { CartService } from './services/cart.service';
import { searchService } from './services/search.service';
import { eventsService } from './services/events.service';

// TODO Auth prompts
import { loginComponent } from './modules/user/auth/login/login.component';
import { signupComponent } from './modules/user/auth/signup/signup.component';
import { forgotPwdComponent } from './modules/user/auth/forgot-pwd/forgot-pwd.component';


@NgModule({
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ],
  declarations: [
    AppComponent,
    headerComponent,
    footerComponent,
    noInternetComponent,
    subHeaderComponent,
    HomeComponent,
    CalendarComponent,
    LoaderComponent,
    MyCartComponent,
    RemovePastOrderComponent,
    RemoveCartItemComponent,
    ZipCodeComponent,
    SearchComponent,
    CartDatesPromptComponent,
    loginComponent,
    signupComponent,
    forgotPwdComponent,
    EditOrderSaveChangesComponent
  ],
  imports: [
    SlickCarouselModule,
    SharedLibrariesModule,
    AppRoutingModule,
    HttpClientModule,
    BrowserAnimationsModule,
    NgSelectModule,
    NgxMaskModule.forRoot(),
    // DragScrollModule,
    NotyfModule
  ],
  entryComponents: [
    headerComponent,
    subHeaderComponent,
    footerComponent,
    noInternetComponent,
    RemovePastOrderComponent,
    RemoveCartItemComponent,
    ZipCodeComponent,
    CartDatesPromptComponent,
    loginComponent,
    signupComponent,
    forgotPwdComponent,
    EditOrderSaveChangesComponent
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: InterceptorClass,
      multi: true
    },
    {
      provide: LocationStrategy,
      useClass: HashLocationStrategy
    },
    LocalStorageService,
    AuthService,
    HomeService,
    CategoryService,
    DateTimeService,
    CommonService,
    AddressBookService,
    AddressValidationService,
    ConfigurationService,
    CartService,
    searchService,
    eventsService
  ],
  bootstrap: [AppComponent]
})

export class AppModule {
  constructor() {
  }
}



// WEBPACK FOOTER //
// ./src/app/app.module.ts